/* ==========================================================================
   Same Skies — PDP "Letter" behaviour (vanilla, no deps)
   Auto-inits from data-attributes. Ported from the static pdp-base.js, with
   the market switch + mobile-nav removed and a real Shopify add-to-cart.
   ========================================================================== */
(function () {
  "use strict";
  var prefersReduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---- SYDNEY CLOCK ------------------------------------------------------ */
  // Dispatch runs on Sydney time wherever the shopper is, so the cut-off and
  // the arrival window both read the clock in Australia/Sydney.
  var sydFmt = null;
  try {
    sydFmt = new Intl.DateTimeFormat("en-AU", {
      timeZone: "Australia/Sydney", hourCycle: "h23",
      year: "numeric", month: "numeric", day: "numeric",
      hour: "numeric", minute: "numeric", second: "numeric"
    });
    if (!sydFmt.formatToParts) sydFmt = null;
  } catch (e) { sydFmt = null; }
  function sydneyParts(now) {
    var p = { y: now.getFullYear(), mo: now.getMonth() + 1, d: now.getDate(), h: now.getHours(), mi: now.getMinutes(), s: now.getSeconds() };
    if (!sydFmt) return p;
    sydFmt.formatToParts(now).forEach(function (part) {
      var v = parseInt(part.value, 10);
      if (part.type === "year") p.y = v;
      else if (part.type === "month") p.mo = v;
      else if (part.type === "day") p.d = v;
      else if (part.type === "hour") p.h = v % 24;
      else if (part.type === "minute") p.mi = v;
      else if (part.type === "second") p.s = v;
    });
    return p;
  }

  /* ---- COUNTDOWN -------------------------------------------------------- */
  // Counts down to the next 14:00 Sydney dispatch cut-off (data-cutoff hour).
  // Targets every [data-countdown] element; format HH:MM:SS, tabular.
  function pad(n) { return String(n).padStart(2, "0"); }
  function initCountdown() {
    var els = document.querySelectorAll("[data-countdown]");
    if (!els.length) return;
    var cutoff = parseInt(els[0].getAttribute("data-cutoff"), 10) || 14;
    function tick() {
      var p = sydneyParts(new Date());
      var diff = cutoff * 3600 - (p.h * 3600 + p.mi * 60 + p.s);
      if (diff <= 0) diff += 86400;
      var h = Math.floor(diff / 3600);
      var m = Math.floor((diff % 3600) / 60);
      var s = diff % 60;
      var txt = pad(h) + ":" + pad(m) + ":" + pad(s);
      els.forEach(function (el) { el.textContent = txt; });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---- ARRIVAL WINDOW ---------------------------------------------------- */
  // Mirrors the Liquid in ss-pdp-letter.liquid (which is served from cache):
  // order date = today in Sydney, or tomorrow past the cut-off, rolled off a
  // weekend; then processing + delivery business days from data-proc/data-deliv.
  // Dates are handled as UTC noon so day steps never cross a DST boundary.
  var MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  var DAY_MS = 86400000;
  function skipWeekend(t) {
    var wd = new Date(t).getUTCDay();
    if (wd === 6) return t + 2 * DAY_MS;
    if (wd === 0) return t + DAY_MS;
    return t;
  }
  function addBusinessDays(t, n) {
    for (var i = 0; i < n; i++) t = skipWeekend(t + DAY_MS);
    return t;
  }
  function fmtDay(t) { var d = new Date(t); return d.getUTCDate() + " " + MONTHS[d.getUTCMonth()]; }
  function initArrival() {
    var el = document.querySelector("[data-arrival]");
    if (!el) return;
    var cutoff = parseInt(el.getAttribute("data-cutoff"), 10) || 14;
    var proc = (el.getAttribute("data-proc") || "1,2").split(",");
    var deliv = (el.getAttribute("data-deliv") || "2,5").split(",");
    var p = sydneyParts(new Date());
    var order = Date.UTC(p.y, p.mo - 1, p.d, 12);
    if (p.h >= cutoff) order += DAY_MS;
    order = skipWeekend(order);
    var a = addBusinessDays(order, parseInt(proc[0], 10) + parseInt(deliv[0], 10));
    var b = addBusinessDays(order, parseInt(proc[1], 10) + parseInt(deliv[1], 10));
    var txt = fmtDay(a) + " - " + fmtDay(b);
    if (el.textContent !== txt) el.textContent = txt;
  }

  /* ---- ACCORDION ------------------------------------------------------- */
  function initAccordion() {
    document.querySelectorAll(".pdp-acc-q").forEach(function (btn) {
      btn.setAttribute("aria-expanded", "false");
      btn.addEventListener("click", function () {
        var item = btn.closest(".pdp-acc-item");
        var ans = item.querySelector(".pdp-acc-a");
        var open = item.classList.toggle("is-open");
        btn.setAttribute("aria-expanded", open ? "true" : "false");
        ans.style.maxHeight = open ? ans.scrollHeight + "px" : 0;
      });
    });
    // keep open panels sized correctly on resize
    window.addEventListener("resize", function () {
      document.querySelectorAll(".pdp-acc-item.is-open .pdp-acc-a").forEach(function (a) {
        a.style.maxHeight = a.scrollHeight + "px";
      });
    });
  }

  /* ---- STICKY ATC BAR -------------------------------------------------- */
  // Slides [data-sticky-bar] up once the [data-sticky-sentinel] (the buy-box
  // ATC row) has scrolled out of view above the fold, and back down when it
  // returns. CSS keeps the bar off desktop; without IO it simply stays hidden.
  function initSticky() {
    var bar = document.querySelector("[data-sticky-bar]");
    if (!bar) return;
    var ticking = false;
    bar.inert = true;
    bar.setAttribute("aria-hidden", "true");
    // Re-query the sentinel on every check: the buy box can be re-rendered after
    // init, and an IntersectionObserver bound to the original node then never
    // fires again (observed on the copy theme 2026-09-02).
    function update() {
      ticking = false;
      var sentinel = document.querySelector("[data-sticky-sentinel]");
      var btn = bar.querySelector("[data-ss-add]");
      var opts = document.querySelector(".ss-pdp [data-ss-opts]");
      // The shortcut is useful only once a purchasable choice is made and the
      // real button has passed above the viewport. Never cover the first fold.
      var ready = !opts || opts.dataset.ready === "true";
      var sr = sentinel && sentinel.getBoundingClientRect();
      var past = !!(sr && sr.bottom < 0);
      // Stepper boxes carry a first-screen CTA under the price (2026-10-16): the bar takes over as soon as that
      // one scrolls under the header, and steps aside whenever the main CTA is on screen, so two buy buttons
      // are never in view together.
      // Edges are the sticky header's real bottom (the announcement bar scrolls away, --header-group-height
      // does not) and the bar's own top edge, so the hand-offs leave no gap and no sliver of a second button.
      var topBtn = document.querySelector("[data-sst-top] [data-ss-add]");
      if (topBtn && topBtn.getClientRects().length) {
        var hdr = 0;
        document.querySelectorAll(".shopify-section-group-header-group").forEach(function (h) {
          hdr = Math.max(hdr, h.getBoundingClientRect().bottom);
        });
        var barTop = window.innerHeight - bar.offsetHeight;
        // +40: when the main CTA is about to arrive (tall tablets), don't flash the bar on for a few px of scroll
        var mainOn = !!(sr && sr.top < Math.max(barTop, window.innerHeight + 40) && sr.bottom > hdr);
        past = topBtn.getBoundingClientRect().bottom < hdr && !mainOn;
      }
      // Never sit on the footer: its links (privacy, cookie preferences, returns) must stay reachable.
      var foot = document.querySelector(".shopify-section-group-footer-group");
      if (foot && foot.getBoundingClientRect().top < window.innerHeight) past = false;
      // Stepper boxes (ss-pdp-steps.js ran, bar has a Next): show once past the buy box whenever the
      // bar has a live control, the Next mid-flow or the ATC once nothing blocks the buy.
      var next = opts && opts.getAttribute("data-sst-ready") ? bar.querySelector("[data-sst-next]") : null;
      var visible = next ?
        past && (!next.hidden || !!(btn && !btn.hidden && !btn.disabled)) :
        !!(past && btn && !btn.disabled && ready);
      bar.classList.toggle("is-visible", visible);
      bar.inert = !visible;
      bar.setAttribute("aria-hidden", visible ? "false" : "true");
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    document.addEventListener("ss:pdp-options-changed", onScroll);
    // the stepper repaints the bar's Next/ATC (wine switch, picks): re-check straight away, not on a frame
    document.addEventListener("sst:progress", update);
    update();
  }


  /* ---- HERO IMAGE SWAP ------------------------------------------------- */
  // Click a [data-swap] thumb to set the [data-hero-img] src (and active state)
  function initSwap() {
    var thumbs = document.querySelectorAll("[data-swap]");
    if (!thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        // re-query the hero each click: it may have been removed by the fallback
        // (failed initial image), in which case there is nothing to swap into.
        var hero = document.querySelector("[data-hero-img]");
        if (!hero) return;
        var src = thumb.getAttribute("data-swap");
        if (!src) return;
        hero.style.opacity = "1";
        // srcset outranks src - clear it (and sizes) or the swap never shows
        hero.removeAttribute("srcset");
        hero.removeAttribute("sizes");
        hero.src = src;
        thumbs.forEach(function (t) { t.classList.remove("is-active"); });
        thumb.classList.add("is-active");
      });
    });
  }

  /* ---- HERO SWIPE (box shot <-> spread, 2026-09-29) --------------------- */
  // Horizontal swipe on the hero steps through the [data-hero-gallery] thumbs
  // by clicking them, so it shares initSwap's src/active handling exactly.
  function initHeroSwipe() {
    var gallery = document.querySelector("[data-hero-gallery]");
    var hero = document.querySelector(".c1-hero-img");
    if (!gallery || !hero) return;
    var x0 = null, y0 = null;
    hero.addEventListener("touchstart", function (e) {
      if (e.touches.length !== 1) { x0 = null; return; }
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    hero.addEventListener("touchend", function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll("[data-swap]"));
      var i = thumbs.findIndex(function (t) { return t.classList.contains("is-active"); });
      var next = thumbs[(Math.max(i, 0) + (dx < 0 ? 1 : thumbs.length - 1)) % thumbs.length];
      if (next) next.click();
    }, { passive: true });
  }

  /* ---- GENERIC REVEAL (optional, opt-in via [data-reveal]) ------------- */
  function initReveal() {
    var els = document.querySelectorAll("[data-reveal]");
    if (!els.length) return;
    if (prefersReduced || !("IntersectionObserver" in window)) {
      els.forEach(function (e) { e.classList.add("is-in"); });
      return;
    }
    // Fire ~half a screen BEFORE the element enters the viewport so the
    // entrance has finished by the time it's visible - reads as instant.
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("is-in"); obs.unobserve(en.target); }
      });
    }, { threshold: 0, rootMargin: "0px 0px 50% 0px" });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---- IMAGE ERROR FALLBACK ------------------------------------------- */
  // Every .ph wrapper has a kraft + monogram fallback behind its <img>.
  // Error handling ONLY: remove the img on failure so a broken-image glyph
  // never shows (the kraft fallback shows through instead).
  // Smooth-Load law: never hide content that may already have painted. The
  // old code set opacity:0 on any not-yet-complete img, which blanked
  // partially-painted progressive JPEGs on slow networks, then faded them
  // back in - a visible flicker. An <img> that hasn't painted yet shows
  // nothing anyway, so only the error case needs JS.
  function initImgFallback() {
    document.querySelectorAll(".ph > img").forEach(function (img) {
      function drop() { img.remove(); }
      if (img.complete) {
        if (img.naturalWidth === 0) { drop(); }
      } else {
        img.addEventListener("error", drop);
      }
    });
  }

  /* ---- ADD TO CART (real Shopify) ------------------------------------- */
  // Reads the variant id from the closest [data-ss-pdp] root, POSTs qty 1 to
  // /cart/add.js (the builder enforces one box per order), then opens cart-drawer-v3.
  function initAddToCart() {
    var adding = false; // shared guard against double-submits
    var buttons = Array.prototype.slice.call(document.querySelectorAll("[data-ss-add]"));
    function isGiftBox(item) {
      return !!(item.properties && item.properties._gift_box) ||
        String(item.product_type || "").toLowerCase() === "gift box" ||
        /^gift-box-/.test(item.handle || "") ||
        ["dusk-box", "twilight-box", "midnight-box", "little-comforts-box", "horizon-box"].indexOf(item.handle) !== -1;
    }
    function showExistingGiftDialog(current) {
      var dialog = document.createElement("dialog");
      dialog.setAttribute("aria-labelledby", "ss-pdp-gift-conflict-title");
      dialog.style.cssText = "max-width:min(440px,calc(100vw - 32px));border:1px solid #e8dccd;border-radius:16px;padding:28px;background:#fffdf9;color:#1e2b38;box-shadow:0 20px 60px #14202e33";
      var heading = document.createElement("h2");
      heading.id = "ss-pdp-gift-conflict-title";
      heading.textContent = "A gift is already in your basket";
      heading.style.cssText = "font:32px/1.1 Georgia,serif;margin:0 0 16px";
      var detail = document.createElement("p");
      detail.textContent = "In basket: " + (current.product_title || current.title || "another gift box") + ". This box has not been added. Remove the old gift before choosing a new one.";
      detail.style.cssText = "font:15px/1.55 Arial,sans-serif;margin:0 0 20px";
      var open = document.createElement("button");
      open.type = "button";
      open.textContent = "Open basket to remove it";
      open.style.cssText = "display:block;width:100%;min-height:46px;border:0;border-radius:24px;background:#a75d3c;color:#fff;font:600 13px Arial,sans-serif;cursor:pointer";
      var back = document.createElement("button");
      back.type = "button";
      back.textContent = "Keep browsing";
      back.style.cssText = "display:block;width:100%;min-height:46px;margin-top:10px;border:1px solid #dfd1c2;border-radius:24px;background:#fff;color:#1e2b38;font:600 13px Arial,sans-serif;cursor:pointer";
      dialog.appendChild(heading);
      dialog.appendChild(detail);
      dialog.appendChild(open);
      dialog.appendChild(back);
      document.body.appendChild(dialog);
      function close(seeBasket) {
        dialog.close();
        dialog.remove();
        if (seeBasket && typeof window.openCartDrawerV3 === "function") { window.openCartDrawerV3({}); return; }
        // "Keep browsing" / Escape: focus back on the Add that was tapped (it was disabled while checking the cart)
        var t = window.__ssCartReturnFocus;
        window.__ssCartReturnFocus = null;
        if (t && t.isConnected && !t.disabled && t.getClientRects().length) t.focus({ preventScroll: true });
      }
      open.addEventListener("click", function () { close(true); });
      back.addEventListener("click", function () { close(false); });
      dialog.addEventListener("cancel", function (e) { e.preventDefault(); close(false); });
      dialog.showModal();
    }
    // capture each button's true original label ONCE, at bind time
    buttons.forEach(function (b) { b.setAttribute("data-orig-label", b.textContent); });

    function setBusy(state) {
      buttons.forEach(function (b) { b.disabled = state; });
      document.querySelectorAll('[data-wine-addon-sw], .c1-opt-pill, .c1-launch-print-pill, .c1-launch-journal-pill').forEach(function(b) {
        if (b.classList.contains('is-oos')) return;
        if (b.tagName === 'A') { b.classList.toggle('is-busy', !!state); if (state) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled'); }
        else b.disabled = state;
      });
    }
    function resetLabels() {
      buttons.forEach(function (b) {
        if (b._errTimer) { clearTimeout(b._errTimer); b._errTimer = null; }
        b.textContent = b.getAttribute("data-orig-label");
      });
    }

    buttons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (adding) return;
        var root = btn.closest("[data-ss-pdp]") || document.querySelector("[data-ss-pdp]");
        var variantId = root && root.getAttribute("data-variant-id");
        if (!variantId) { console.warn("[ss-pdp] no variant id"); return; }

        var printWrap = document.querySelector('[data-launch-print-choice]');
        var printChoice = printWrap && printWrap.querySelector('[data-print-val][aria-checked="true"]');
        if (printWrap && !printChoice) { printWrap.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        var journalWrap = document.querySelector('[data-launch-journal-choice]');
        var journalChoice = journalWrap && journalWrap.querySelector('[data-journal-val][aria-checked="true"]');
        if (journalWrap && !journalChoice) { journalWrap.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        var boxItem = { id: Number(variantId), quantity: 1 };
        if (printChoice) boxItem.properties = Object.assign(boxItem.properties || {}, { 'Print design': printChoice.getAttribute('data-print-val') });
        if (journalChoice) boxItem.properties = Object.assign(boxItem.properties || {}, { 'Journal colour': journalChoice.getAttribute('data-journal-val') });
        if (printChoice) {
          try {
            if (!window.SSBoxBundles) throw new Error('Could not prepare your box. Please refresh and try again.');
            boxItem = window.SSBoxBundles.prepare(boxItem);
            variantId = String(boxItem.id);
          } catch (error) {
            var purchaseError = document.querySelector('[data-purchase-error]');
            if (purchaseError) { purchaseError.hidden = false; purchaseError.textContent = error.message; }
            return;
          }
        }
        var items = [boxItem];
        var wine = document.querySelector('[data-wine-addon-sw][aria-checked="true"]');
        if (wine && wine.getAttribute('data-vid')) {
          var age = document.querySelector('[data-wine-age]');
          var ageError = document.querySelector('[data-wine-age-error]');
          if (!age || !age.checked) {
            if (ageError) ageError.hidden = false;
            if (age) {
              age.setAttribute('aria-invalid', 'true');
              if (ageError && ageError.id) age.setAttribute('aria-describedby', ageError.id);
              age.focus();
            }
            return;
          }
          if (ageError) ageError.hidden = true;
          items.push({ id: Number(wine.getAttribute('data-vid')), quantity: 1, properties: { 'Recipient 18+': 'Confirmed' } });
        }
        var errorEl = document.querySelector('[data-purchase-error]');
        if (errorEl) errorEl.hidden = true;
        // setBusy disables this button, which drops focus to <body>: tell the cart drawer where to return it
        window.__ssCartReturnFocus = btn;
        adding = true;
        setBusy(true);                 // disable BOTH ATC buttons while in flight
        if (btn._errTimer) { clearTimeout(btn._errTimer); btn._errTimer = null; }
        btn.textContent = "Adding…";

        fetch("/cart.js", { headers: { "Accept": "application/json" } })
          .then(function (res) {
            if (!res.ok) throw new Error("Could not check your basket. Please try again.");
            return res.json();
          })
          .then(function (cart) {
            var existing = (cart.items || []).filter(isGiftBox)[0];
            if (existing) {
              showExistingGiftDialog(existing);
              var limitError = new Error("Another gift is already in your basket");
              limitError.giftLimit = true;
              throw limitError;
            }
            // the add really goes ahead now: ss-pdp-steps.js counts ss_atc_click on this, never on a blocked tap
            document.dispatchEvent(new CustomEvent("ss:pdp-add-start", { detail: { variantId: root.getAttribute("data-variant-id"),
              cta: btn.closest("[data-sst-top]") ? "top" : btn.closest("[data-sticky-bar]") ? "sticky" : "main" } }));
            return fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ items: items })
            });
          })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) {
                throw new Error((data && data.description) || "Add to cart failed");
              }
              return data;
            });
          })
          .then(function (addResp) {
            if (!addResp || !addResp.items || !addResp.items.some(function (item) {
              return Number(item.variant_id || item.id) === Number(variantId);
            })) throw new Error("Could not confirm this gift in your basket");
            var justAddedHandle = (root && root.getAttribute("data-handle")) ||
              (addResp.items && addResp.items[0] && addResp.items[0].handle);
            adding = false;
            setBusy(false);
            resetLabels();             // clear any stale "Try again" + restore original labels
            if (typeof window.openCartDrawerV3 === "function") {
              window.openCartDrawerV3({ justAddedHandle: justAddedHandle, expectItems: true, addResp: addResp });
            }
          })
          .catch(function (err) {
            adding = false;
            setBusy(false);
            if (err && err.giftLimit) { resetLabels(); return; }
            console.error("[ss-pdp] add to cart:", err && err.message ? err.message : err);
            if (errorEl) { errorEl.hidden = false; errorEl.textContent = err.message || 'Could not add your gift. Please try again.'; }
            btn.textContent = "Try again";
            btn._errTimer = setTimeout(function () {
              btn.textContent = btn.getAttribute("data-orig-label");
              btn._errTimer = null;
            }, 1600);
          });
      });
    });
  }

  /* ---- BUNDLE OPTION SELECTOR (choose your print / scent) ------------- */
  // Renders only when the box is a multi-variant bundle. Gates every
  // [data-ss-add] button (buy-box + sticky) until each option group has a
  // selection, then resolves the matching variant id and writes it to the
  // [data-ss-pdp] root so the existing ATC handler posts the right variant.
  // Must run AFTER initAddToCart so data-orig-label captured the true label.
  function initOptions() {
    var wrap = document.querySelector(".ss-pdp [data-ss-opts]");
    if (!wrap) return; // single-variant box → nothing to do
    var root = document.querySelector("[data-ss-pdp]");
    var shownId = root && root.getAttribute("data-variant-id"); // selected_or_first_available_variant, before any pick
    var dataEl = document.querySelector(".ss-pdp [data-ss-variants]");
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var addBtns = Array.prototype.slice.call(document.querySelectorAll("[data-ss-add]"));
    var hint = wrap.querySelector("[data-opt-hint]");
    var groupEls = Array.prototype.slice.call(wrap.querySelectorAll("[data-opt-group]"));
    var groupCount = groupEls.length;
    var chosen = {}; // position(string) -> value
    var printWrap = wrap.querySelector('[data-launch-print-choice]');
    var journalWrap = wrap.querySelector('[data-launch-journal-choice]');
    var journalVariants = { Red: variants };

    function selectedJournal() {
      var pill = journalWrap && journalWrap.querySelector('[data-journal-val][aria-checked="true"]');
      return pill ? pill.getAttribute('data-journal-val') : null;
    }

    function activeVariants() {
      if (!journalWrap) return variants;
      var journal = selectedJournal();
      return journal ? (journalVariants[journal] || []) : Object.keys(journalVariants).reduce(function (all, name) {
        return all.concat(journalVariants[name]);
      }, []);
    }

    function setLabel(b, txt) { b.textContent = txt; }

    function gate() {
      var keys = Object.keys(chosen);
      var complete = keys.length === groupCount;
      var match = complete ? resolve() : null;
      var printChosen = !printWrap || !!printWrap.querySelector('[data-print-val][aria-checked="true"]');
      var journalChosen = !journalWrap || !!selectedJournal();
      var buyable = complete && match && match.available && printChosen && journalChosen;

      addBtns.forEach(function (b) {
        b.disabled = !buyable;
        if (!complete) {
          setLabel(b, "Choose your options");
        } else if (!journalChosen) {
          setLabel(b, "Choose your journal");
        } else if (!match || !match.available) {
          setLabel(b, "Sold out");
        } else if (!printChosen) {
          setLabel(b, "Choose your print");
        } else {
          setLabel(b, b.getAttribute("data-orig-label"));
        }
      });
      wrap.dataset.ready = buyable ? "true" : "false";
      if (hint) hint.style.display = complete && printChosen && journalChosen ? "none" : "";

      // Sync the resolved variant to EVERY purchase path, not just the buy-box
      // root: the sticky-bar ATC is a separate [data-ss-pdp] root. Without this
      // it silently buys the default/first variant regardless of the pick.
      if (match) {
        document.querySelectorAll("[data-ss-pdp]").forEach(function (r) {
          r.setAttribute("data-variant-id", match.id);
          r.setAttribute("data-price-cents", match.price);
        });
        var hid = document.querySelector('#ss-pdp-form input[name="id"]');
        if (hid && hid.value !== String(match.id)) {
          hid.value = match.id;
          hid.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
      updatePurchaseLabels();
      document.dispatchEvent(new Event("ss:pdp-options-changed"));
    }

    function resolve() {
      var want = [];
      for (var i = 1; i <= groupCount; i++) want.push(chosen[String(i)]);
      var pool = journalWrap ? (journalVariants[selectedJournal()] || []) : variants;
      return pool.filter(function (v) {
        return v.opts.slice(0, groupCount).join("␟") === want.join("␟");
      })[0] || null;
    }

    // ── sold-out greying (context-aware) ─────────────────────────────────
    // A pill is dead if NO available variant matches its value PLUS the values
    // already chosen in the OTHER groups. Re-evaluated after every selection.
    function refreshOOS() {
      wrap.querySelectorAll(".c1-opt-pill[data-opt-pos]").forEach(function (p) {
        var pos = p.getAttribute("data-opt-pos");
        var val = p.getAttribute("data-opt-val");
        var alive = activeVariants().some(function (v) {
          if (!v.available) return false;
          if (v.opts[Number(pos) - 1] !== val) return false;
          for (var i = 1; i <= groupCount; i++) {
            if (String(i) === pos) continue;
            if (chosen[String(i)] && v.opts[i - 1] !== chosen[String(i)]) return false;
          }
          return true;
        });
        p.classList.toggle("is-oos", !alive);
        p.setAttribute("aria-disabled", alive ? "false" : "true");
      });
      if (journalWrap) {
        journalWrap.querySelectorAll('[data-journal-val]').forEach(function (p) {
          var pool = journalVariants[p.getAttribute('data-journal-val')] || [];
          var alive = pool.some(function (v) {
            if (!v.available) return false;
            for (var i = 1; i <= groupCount; i++) {
              if (chosen[String(i)] && v.opts[i - 1] !== chosen[String(i)]) return false;
            }
            return true;
          });
          p.setAttribute('aria-disabled', alive ? 'false' : 'true');
        });
      }
    }

    function selectPill(pill) {
      if (pill.classList.contains("is-oos")) return; // sold out — not selectable
      var pos = pill.getAttribute("data-opt-pos");
      wrap.querySelectorAll('.c1-opt-pill[data-opt-pos="' + pos + '"]').forEach(function (p) {
        p.classList.remove("is-sel");
        p.setAttribute("aria-checked", "false");
      });
      pill.classList.add("is-sel");
      pill.setAttribute("aria-checked", "true");
      chosen[pos] = pill.getAttribute("data-opt-val");
      // compact pickers: echo the chosen value into the group header
      var grp = pill.closest("[data-opt-group]");
      var sel = grp && grp.querySelector("[data-opt-selname]");
      if (sel) sel.textContent = pill.getAttribute("data-opt-val");
      // Print preview panel (2026-07-06): keep the always-visible hero image
      // in sync with whichever design is selected. Scoped to the print
      // option group only (data-print-opt), so candle-scent picks never
      // touch it. data-large already exists on every swatch for the zoom
      // viewer, so no new data source needed here.
      if (grp && grp.hasAttribute("data-print-opt") && pill.classList.contains("is-swatch")) {
        var heroImg = document.querySelector("[data-print-hero-img]");
        var large = pill.getAttribute("data-large");
        if (heroImg && large) heroImg.src = large;
      }
      refreshOOS();
      gate();
    }

    wrap.querySelectorAll(".c1-opt-pill[data-opt-pos]").forEach(function (pill) {
      pill.addEventListener("click", function () { selectPill(pill); });
    });
    function markPrint(pill) {
      printWrap.querySelectorAll('[data-print-val]').forEach(function (p) { p.setAttribute('aria-checked', 'false'); });
      pill.setAttribute('aria-checked', 'true');
      var label = printWrap.querySelector('[data-print-selname]');
      if (label) label.textContent = pill.getAttribute('data-print-val');
    }
    if (printWrap) {
      printWrap.querySelectorAll('[data-print-val]').forEach(function (pill) {
        pill.addEventListener('click', function () {
          if (pill.classList.contains('is-oos')) return;
          markPrint(pill);
          var insidePrint = document.querySelector('[data-inside-print-img]');
          if (insidePrint) insidePrint.src = pill.getAttribute('data-card-image');
          gate();
        });
      });
    }
    if (journalWrap) {
      journalWrap.querySelectorAll('[data-journal-val]').forEach(function (pill) {
        pill.addEventListener('click', function () {
          if (pill.getAttribute('aria-disabled') === 'true') return;
          journalWrap.querySelectorAll('[data-journal-val]').forEach(function (p) { p.setAttribute('aria-checked', 'false'); });
          pill.setAttribute('aria-checked', 'true');
          var label = journalWrap.querySelector('[data-journal-selname]');
          if (label) label.textContent = pill.getAttribute('data-journal-val');
          refreshOOS();
          gate();
        });
      });
      journalWrap.querySelectorAll('[data-journal-handle]').forEach(function (pill) {
        var handle = pill.getAttribute('data-journal-handle');
        var expectedId = Number(pill.getAttribute('data-product-id'));
        var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
        fetch(rootPath + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
          .then(function (res) { if (!res.ok) throw new Error('Journal product unavailable'); return res.json(); })
          .then(function (product) {
            if (Number(product.id) !== expectedId || !Array.isArray(product.variants)) throw new Error('Journal product mismatch');
            journalVariants[pill.getAttribute('data-journal-val')] = product.variants.map(function (v) {
              return { id: v.id, opts: v.options || [v.option1, v.option2, v.option3].filter(Boolean), available: v.available, price: v.price };
            });
            refreshOOS();
            gate();
          })
          .catch(function (err) { console.error('[ss-pdp] journal choices:', err.message); });
      });
    }

    // ── swatch viewer (magnifier badge → large preview + browse + choose) ─
    (function initSwatchViewer() {
      var swv = document.querySelector(".ss-pdp [data-swv]") || document.querySelector("[data-swv]");
      if (!swv) return;
      // PORTAL: move to <body> so no transformed ancestor can trap the fixed
      // overlay or stack content above it (ghost-drawer lesson).
      if (swv.parentElement !== document.body) document.body.appendChild(swv);
      var imgEl = swv.querySelector("[data-swv-img]");
      var nameEl = swv.querySelector("[data-swv-name]");
      var countEl = swv.querySelector("[data-swv-count]");
      var chooseBtn = swv.querySelector("[data-swv-choose]");
      var list = [];   // swatch buttons in the active group
      var idx = 0;
      var opener = null;

      function render() {
        var sw = list[idx];
        if (!sw) return;
        var name = sw.getAttribute("data-print-val") || sw.getAttribute("data-opt-val") || sw.getAttribute("data-sw-name");
        imgEl.src = sw.getAttribute("data-large");
        imgEl.alt = name;
        nameEl.textContent = name;
        countEl.textContent = (idx + 1) + " / " + list.length;
        var oos = sw.classList.contains("is-oos");
        chooseBtn.disabled = oos;
        chooseBtn.textContent = oos ? "Sold out" : "Choose this";
      }
      function open(fromSwatch) {
        if (fromSwatch.tagName === "A") {
          // journal colours are links to sibling products, not variant options
          list = Array.prototype.slice.call(fromSwatch.closest(".c1-opt-pills").querySelectorAll("a.c1-opt-pill.is-swatch"));
        } else if (fromSwatch.hasAttribute("data-print-val")) {
          list = Array.prototype.slice.call(printWrap.querySelectorAll(".c1-launch-print-pill.is-swatch"));
        } else {
          var pos = fromSwatch.getAttribute("data-opt-pos");
          list = Array.prototype.slice.call(
            wrap.querySelectorAll('.c1-opt-pill.is-swatch[data-opt-pos="' + pos + '"]'));
        }
        idx = list.indexOf(fromSwatch);
        if (idx < 0) idx = 0;
        opener = document.activeElement;
        render();
        swv.hidden = false;
        document.documentElement.classList.add("c1-swv-open");
        (chooseBtn.disabled ? swv.querySelector(".c1-swv-x") : chooseBtn).focus({ preventScroll: true });
      }
      function focusables() {
        return Array.prototype.filter.call(swv.querySelectorAll("button"), function (b) {
          return !b.disabled && b.offsetParent !== null;
        });
      }
      function close() {
        if (swv.hidden) return;
        swv.hidden = true;
        document.documentElement.classList.remove("c1-swv-open");
        // Choose this may hand focus on to the next step; only take it back when nothing else claimed it
        var a = document.activeElement;
        if (opener && document.body.contains(opener) && (!a || a === document.body || swv.contains(a))) opener.focus({ preventScroll: true });
        opener = null;
      }
      swv.querySelectorAll("[data-swv-close]").forEach(function (b) { b.addEventListener("click", close); });
      swv.querySelector("[data-swv-prev]").addEventListener("click", function () { idx = (idx - 1 + list.length) % list.length; render(); });
      swv.querySelector("[data-swv-next]").addEventListener("click", function () { idx = (idx + 1) % list.length; render(); });
      chooseBtn.addEventListener("click", function () {
        if (list[idx]) {
          if (list[idx].tagName === "A") { if (!list[idx].classList.contains("is-sel")) window.location.href = list[idx].href; }
          else if (list[idx].hasAttribute("data-print-val")) list[idx].click();
          else selectPill(list[idx]);
        }
        close();
      });
      document.addEventListener("keydown", function (e) {
        if (swv.hidden) return;
        if (e.key === "Tab") {
          var f = focusables();
          if (!f.length) return;
          var at = f.indexOf(document.activeElement);
          if (e.shiftKey && at <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
          else if (!e.shiftKey && (at === -1 || at === f.length - 1)) { e.preventDefault(); f[0].focus(); }
          return;
        }
        if (e.key === "Escape") close();
        if (e.key === "ArrowLeft") { idx = (idx - 1 + list.length) % list.length; render(); }
        if (e.key === "ArrowRight") { idx = (idx + 1) % list.length; render(); }
      });
      document.querySelectorAll(".ss-pdp [data-ss-opts] [data-sw-zoom], .ss-pdp .c1-journal-opts [data-sw-zoom]").forEach(function (z) {
        z.addEventListener("click", function (e) {
          e.stopPropagation();
          open(z.parentElement.querySelector(".c1-opt-pill.is-swatch, .c1-launch-print-pill.is-swatch"));
        });
      });
    })();

    refreshOOS();

    // If a disabled sticky/buy ATC is tapped, scroll the shopper to the options.
    addBtns.forEach(function (b) {
      b.addEventListener("click", function (e) {
        if (b.disabled) {
          e.preventDefault();
          wrap.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, true);
    });

    gate(); // start gated (nothing chosen)

    // ?variant= deep links (catalogue ads, shared links) land on the linked
    // combination instead of a blank picker. A sold-out link stays unpicked so
    // the shopper chooses from what is in stock rather than meeting a dead button.
    var linked = null;
    try {
      var linkedId = new URLSearchParams(window.location.search).get("variant");
      linked = linkedId && variants.filter(function (v) { return String(v.id) === linkedId; })[0];
      if (linked && linked.available && Array.isArray(linked.opts)) {
        linked.opts.forEach(function (val, i) {
          var pill = wrap.querySelector('.c1-opt-pill[data-opt-pos="' + (i + 1) + '"][data-opt-val="' + CSS.escape(String(val)) + '"]');
          if (pill) selectPill(pill);
        });
      }
    } catch (e) {}

    // ss_opts carries the other picks across the Traveller journal links ("Green|Blue|"):
    // one value per option position, empty = not chosen, "|" is the separator. Sibling products must keep
    // identical option values and order. Sold-out values stay unpicked; a usable ?variant= wins.
    try {
      var carried = new URLSearchParams(window.location.search).get("ss_opts");
      if (carried && !(linked && linked.available)) carried.split("|").forEach(function (val, i) {
        if (!val) return;
        var esc = window.CSS && CSS.escape ? CSS.escape(val) : val.replace(/"/g, '\\"');
        var pill = wrap.querySelector('.c1-opt-pill[data-opt-pos="' + (i + 1) + '"][data-opt-val="' + esc + '"]');
        if (pill && !pill.classList.contains("is-oos")) selectPill(pill);
      });
    } catch (e) {}

    // Pre-selected set (2026-10-12): with no usable ?variant= and no ss_opts the box loads as our favourite
    // set, every step already chosen: the shown variant (else the first available one) through selectPill, so
    // the gate, price and variant id on every [data-ss-pdp] root run exactly as for a user pick. Sold-out values
    // are never defaulted. Flags go on first, before any gate() paints:
    //   data-sst-default    the favourite set drove the options ("Our favourite set" line, ss_atc_ready
    //                       source=default; ss-pdp-steps.js drops it on a real change). Never set on a deep link.
    //   data-sst-default-pick on each defaulted pill / card / journal link (ss_pick_changed from_default)
    // The print fills whenever it is unpicked, deep link or not (ads land ready to buy). ?ss_print=<print name>
    // (2026-10-17, ads and the journal links) names it; an unknown, sold-out or disabled name is ignored. Otherwise
    // the box's own print, the one its What's inside tile shows. The own print is set in place with no click so
    // nothing on the page moves; any other goes through its own click handler (photo + caption follow; an
    // untrusted click, which ss-pdp-steps.js never counts as the shopper). If neither is available, the first
    // available card. Only a print we chose is flagged data-sst-default-pick; a linked one is the link's.
    try {
      var fullSet = !(linked && linked.available) && !carried;
      var printCard = null, printOwn = false, linkedPrint = null;
      if (printWrap && !printWrap.querySelector('[data-print-val][aria-checked="true"]')) {
        var tile = document.querySelector("[data-inside-print-img][data-print-name]");
        var ownName = tile && tile.getAttribute("data-print-name");
        var cards = Array.prototype.slice.call(printWrap.querySelectorAll('[data-print-val]:not(.is-oos):not([disabled])'));
        var asked = (new URLSearchParams(window.location.search).get("ss_print") || "").trim().toLowerCase();
        if (asked) linkedPrint = cards.filter(function (c) { return c.getAttribute("data-print-val").trim().toLowerCase() === asked; })[0] || null;
        printCard = linkedPrint || cards.filter(function (c) { return c.getAttribute("data-print-val") === ownName; })[0] || null;
        printOwn = !!printCard && printCard.getAttribute("data-print-val") === ownName;
        if (!printCard) printCard = cards[0] || null;
      }
      if (fullSet) {
        wrap.setAttribute("data-sst-default", "");
        var shown = variants.filter(function (v) { return String(v.id) === shownId && v.available; })[0] ||
          variants.filter(function (v) { return v.available; })[0];
        if (shown && Array.isArray(shown.opts)) shown.opts.forEach(function (val, i) {
          var pill = wrap.querySelector('.c1-opt-pill[data-opt-pos="' + (i + 1) + '"][data-opt-val="' + CSS.escape(String(val)) + '"]');
          if (pill && !pill.classList.contains("is-oos")) { pill.setAttribute("data-sst-default-pick", ""); selectPill(pill); }
        });
        // Traveller: the journal is the page's own colour, chosen server-side, so it is part of the set
        wrap.querySelectorAll('[data-sst-kind="journal"] a.c1-opt-pill.is-sel').forEach(function (a) { a.setAttribute("data-sst-default-pick", ""); });
      }
      if (printCard) {
        if (!linkedPrint) printCard.setAttribute("data-sst-default-pick", "");
        if (printOwn) { markPrint(printCard); gate(); } else printCard.click();
      }
    } catch (e) {}
  }

  /* ---- MOBILE SEGMENTED TABS (Inside / Allergens / Details) ---------- */
  // CSS (max-width:749px) shows only the active information panel. Keep the
  // tab roles and keyboard focus in step with the visible content.
  function initMTabs() {
    var bar = document.querySelector("[data-mtabs]");
    if (!bar) return;
    var root = document.querySelector('.ss-pdp[data-mtab]') || document.querySelector("[data-ss-pdp]");
    var pill = bar.querySelector("[data-mpill]");
    var btns = Array.prototype.slice.call(bar.querySelectorAll("[data-mtab-btn]"));
    function select(btn, focus) {
      var index = btns.indexOf(btn);
      btns.forEach(function (b) {
        var active = b === btn;
        b.classList.toggle("is-active", active);
        b.setAttribute("aria-selected", active ? "true" : "false");
        b.tabIndex = active ? 0 : -1;
      });
      if (pill) pill.style.transform = "translateX(" + (index * 100) + "%)";
      if (root) root.setAttribute("data-mtab", btn.getAttribute("data-mtab-btn"));
      if (focus) btn.focus();
    }
    btns.forEach(function (btn, i) {
      btn.addEventListener("click", function () { select(btn, false); });
      btn.addEventListener("keydown", function (event) {
        var next = i;
        if (event.key === "ArrowRight") next = (i + 1) % btns.length;
        else if (event.key === "ArrowLeft") next = (i - 1 + btns.length) % btns.length;
        else if (event.key === "Home") next = 0;
        else if (event.key === "End") next = btns.length - 1;
        else return;
        event.preventDefault();
        select(btns[next], true);
      });
    });
  }

  // Single-row swatch strips: toggle at-start/at-end so the CSS edge-fade only
  // shows on the side with more to scroll, + drag-to-scroll for desktop mice.
  function initSwatchRail() {
    var rails = document.querySelectorAll(".c1-opt-pills.is-swatches");
    if (!rails.length) return;
    Array.prototype.forEach.call(rails, function (rail) {
      function update() {
        var max = rail.scrollWidth - rail.clientWidth;
        if (max <= 1) { rail.classList.add("at-start"); rail.classList.add("at-end"); return; }
        var x = rail.scrollLeft;
        rail.classList.toggle("at-start", x <= 1);
        rail.classList.toggle("at-end", x >= max - 1);
      }
      var rafPending = false;
      function onScroll() {
        if (rafPending) return;
        rafPending = true;
        requestAnimationFrame(function () { rafPending = false; update(); });
      }
      rail.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll);
      // desktop damped-wheel physics if the shared helper is present (not on PDP today)
      if (window.ssHorizontalScroll && window.ssHorizontalScroll.wire) {
        try { window.ssHorizontalScroll.wire(rail); } catch (e) {}
      }
      // click-and-drag to scroll for mouse users; touch/trackpad use native scroll
      if (window.matchMedia("(min-width: 769px)").matches) {
        var dragging = false, startX = 0, startScroll = 0, moved = 0, activeId = null;
        rail.addEventListener("pointerdown", function (e) {
          if (e.pointerType !== "mouse") return;
          // Don't start a drag when the press lands on a swatch/pill (or its
          // image/label) - otherwise any few-px jitter during a normal click is
          // treated as a drag and the select-click is swallowed (= "nothing
          // selects"). Drag-to-scroll still works from the gaps/background.
          // Matches the locked Horizontal Scroll Pattern guard.
          if (e.target.closest("a, button")) return;
          dragging = true; moved = 0; startX = e.clientX; startScroll = rail.scrollLeft; activeId = e.pointerId;
          rail.classList.add("is-grabbing");
          try { rail.setPointerCapture(e.pointerId); } catch (_) {}
        });
        rail.addEventListener("pointermove", function (e) {
          if (!dragging || e.pointerId !== activeId) return;
          var dx = e.clientX - startX;
          if (Math.abs(dx) > moved) moved = Math.abs(dx);
          rail.scrollLeft = startScroll - dx;
        });
        function endDrag() {
          if (!dragging) return;
          dragging = false; rail.classList.remove("is-grabbing");
          try { rail.releasePointerCapture(activeId); } catch (_) {}
        }
        ["pointerup", "pointercancel", "pointerleave"].forEach(function (t) { rail.addEventListener(t, endDrag); });
        // if the pointer actually dragged, swallow the swatch-select click
        rail.addEventListener("click", function (e) {
          if (moved > 6) { e.stopPropagation(); e.preventDefault(); moved = 0; }
        }, true);
      }
      update();
    });
  }

  /* ---- PICCOLO WINE ADD-ON -------------------------------------------- */
  function updatePurchaseLabels() {
    var root = document.querySelector('[data-ss-pdp]');
    if (!root) return;
    var wine = document.querySelector('[data-wine-addon-sw][aria-checked="true"]');
    var box = Number(root.getAttribute('data-price-cents'));
    var wineCents = Number(wine && wine.getAttribute('data-price-cents') || 0);
    var cur = root.getAttribute('data-currency') || 'AUD';
    if (cur === 'AUD' && Date.now() < 1793491199000) {
      if (box === 14900) box = 13500;
      else if (box === 17900) box = 15500;
    }
    var boxLabel = document.querySelector('[data-sst-box-price-label]');
    if (boxLabel) boxLabel.hidden = !wineCents;
    var total = box + wineCents;
    var whole = total % 100 === 0;
    function fmtWith(narrow) {
      var fmt = { style: 'currency', currency: cur };
      if (narrow) fmt.currencyDisplay = 'narrowSymbol';
      if (whole) { fmt.minimumFractionDigits = 0; fmt.maximumFractionDigits = 0; }
      return new Intl.NumberFormat('en-GB', fmt).format(total / 100);
    }
    var amount;
    // iOS Safari before 14.5 throws RangeError on narrowSymbol
    try { amount = fmtWith(true); } catch (e) { amount = fmtWith(false); }
    document.querySelectorAll('[data-ss-add]').forEach(function(b) {
      // In the stepper CTAs (buy box + phone sticky bar) the price sits beside the button, so no price in the label
      b.setAttribute('data-orig-label', b.closest('.sst-cta, .sst-cta-sb, .sst-cta-top') ? 'Add to basket' : 'Add to basket · ' + amount);
      if (!b.disabled) b.textContent = b.getAttribute('data-orig-label');
    });
    document.querySelectorAll('[data-sst-cta-amt]').forEach(function(el) { el.textContent = amount; });
    var stickyPrice = document.querySelector('.sb-price');
    if (stickyPrice) stickyPrice.textContent = amount;
  }

  function initWineAddon() {
    var box = document.querySelector('[data-wine-addon]');
    if (!box) return;
    var chips = Array.prototype.slice.call(box.querySelectorAll('[data-wine-addon-sw]'));
    chips.forEach(function(chip) {
      chip.addEventListener('click', function() {
        chips.forEach(function(c) {
          c.classList.toggle('is-sel', c === chip);
          c.setAttribute('aria-checked', String(c === chip));
        });
        box.querySelector('[data-wine-notice]').hidden = !chip.getAttribute('data-vid');
        box.querySelector('[data-wine-age-wrap]').hidden = !chip.getAttribute('data-vid');
        // Keep the 18+ tick between bottles (it confirms ages, not the varietal);
        // only "No thanks" clears it. Matches the cart drawer (2026-10-06).
        if (!chip.getAttribute('data-vid')) box.querySelector('[data-wine-age]').checked = false;
        clearAgeError();
        updatePurchaseLabels();
      });
    });
    var age = box.querySelector('[data-wine-age]');
    var ageError = box.querySelector('[data-wine-age-error]');
    function clearAgeError() {
      if (ageError) ageError.hidden = true;
      if (age) { age.removeAttribute('aria-invalid'); age.removeAttribute('aria-describedby'); }
    }
    if (age) age.addEventListener('change', function () { if (age.checked) clearAgeError(); });
    updatePurchaseLabels();
  }

  /* ---- WARM LARGE IMAGES ------------------------------------------------ */
  // Every zoom surface (swatch viewer, print hero, print lightbox) sets
  // img.src = data-large AT CLICK TIME, so the 1200px fetch used to start
  // only after the tap — a visible wait on mobile. Warm every unique
  // data-large URL into the HTTP cache once the page is idle, so opening
  // any viewer is a cache hit. new Image() (not <link rel=prefetch>)
  // because Safari never shipped prefetch. Runs after window load +
  // idle so it can't compete with the LCP hero or critical requests.
  function initWarmLargeImages() {
    // Respect Data Saver / very slow connections — the click-time load
    // (with its wait) is the right trade there.
    var conn = navigator.connection || {};
    if (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || "")) return;
    function warm() {
      var seen = {};
      function go(u) {
        if (!u || seen[u]) return;
        seen[u] = 1;
        var im = new Image();
        im.decoding = "async";
        try { im.fetchPriority = "low"; } catch (e) { /* older browsers */ }
        im.src = u;
      }
      // data-large: swatch viewer / print hero / print lightbox (1200px)
      // data-swap:  gallery thumbnail -> hero swaps (900px)
      // Stepper boxes carry a 1200px zoom image on every option card (24 on For Her, ~1.4MB), so
      // those warm per step when it opens instead of all up front (2026-10-06).
      var stepper = document.querySelector(".ss-pdp .c1-buy.has-sst");
      document.querySelectorAll(stepper ? "[data-swap]" : "[data-large], [data-swap]").forEach(function (el) {
        go(el.getAttribute("data-large") || el.getAttribute("data-swap"));
      });
      if (!stepper) return;
      function warmIn(root) {
        root.querySelectorAll("[data-large]").forEach(function (el) { go(el.getAttribute("data-large")); });
      }
      document.querySelectorAll(".ss-pdp [data-sst-body]:not([hidden])").forEach(warmIn);
      // ss-pdp-steps.js fires sst:open (non-bubbling) on a step body as it opens: catch it on capture
      document.addEventListener("sst:open", function (e) { warmIn(e.target); }, true);
    }
    // DOMContentLoaded + idle, never the load event alone: one slow third-party held
    // load for 24s on this template and the warm with it (Snappy Standard rule).
    // 2026-10-12: and not before the shopper's first scroll/tap (or window load), via
    // the section's ssArm, so these full-size images stay out of the way of the Meta
    // pixel on a cold phone load.
    function afterReady() {
      var idle = function () {
        if ("requestIdleCallback" in window) requestIdleCallback(warm, { timeout: 4000 });
        else setTimeout(warm, 1500);
      };
      if (window.ssArm) window.ssArm(idle); else idle();
    }
    if (document.readyState !== "loading") afterReady();
    else document.addEventListener("DOMContentLoaded", afterReady, { once: true });
  }

  function init() {
    initImgFallback();
    initCountdown();
    initArrival();
    initAccordion();
    initSticky();
    initSwap();
    initHeroSwipe();
    initReveal();
    initAddToCart();
    initOptions();
    initMTabs();
    initSwatchRail();
    initWineAddon();
    initWarmLargeImages();
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else { init(); }
})();

